import { Injectable } from '@angular/core';
import { SettingsProvider } from '@services/settings/settings';
import { MessageService } from '@services/helpers/message-service/message.service';
import { CustomizedLabels } from '@models/models';

@Injectable()
export class CustomizeLabelsService {
	customizeLabels: CustomizedLabels;

	constructor(
		private settingsService: SettingsProvider,
		private messageService: MessageService
	) {
		this.settingsService.customizeLabelsObservable.subscribe(
			(data: CustomizedLabels): void => {
				this.customizeLabels = data;
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/settings/customize.labels.service.ts